import React, { useState } from 'react';
import { ManagementHomePage, PayScaleModule, CrewOrganizerModule, PasswordsModule, RunningJobSummaryModule, FieldFormsModule } from './ManagementGear';
import FleetModule from '../components/fleet/FleetModule';
import PerformanceMetricsModule from '../components/management/PerformanceMetricsModule';
import CompanyContactsModule from '../components/management/CompanyContactsModule';

const ManagementGearPage = ({ currentUser, onBackToGears }) => {
  const [currentPage, setCurrentPage] = useState('home');

  switch (currentPage) {
    case 'home':
      return <ManagementHomePage onNavigate={setCurrentPage} onBackToGears={onBackToGears} currentUser={currentUser} />;
    case 'crew-organizer':
      return <CrewOrganizerModule onBack={() => setCurrentPage('home')} currentUser={currentUser} />;
    case 'passwords':
      if (currentUser?.rawRole === 'admin') {
        return <PasswordsModule onBack={() => setCurrentPage('home')} currentUser={currentUser} />;
      } else {
        return <ManagementHomePage onNavigate={setCurrentPage} onBackToGears={onBackToGears} currentUser={currentUser} />;
      }
    case 'running-job-summary':
      if (currentUser?.rawRole === 'admin') {
        return <RunningJobSummaryModule onBack={() => setCurrentPage('home')} currentUser={currentUser} />;
      } else {
        return <ManagementHomePage onNavigate={setCurrentPage} onBackToGears={onBackToGears} currentUser={currentUser} />;
      }
    case 'fleet':
      return <FleetModule onBack={() => setCurrentPage('home')} currentUser={currentUser} />;
    case 'pay-scale':
      return <PayScaleModule onBack={() => setCurrentPage('home')} currentUser={currentUser} />;
    case 'field-forms':
      return <FieldFormsModule onBack={() => setCurrentPage('home')} currentUser={currentUser} />;
    case 'performance-metrics':
      return <PerformanceMetricsModule onBack={() => setCurrentPage('home')} currentUser={currentUser} />;
    case 'company-contacts':
      return <CompanyContactsModule onBack={() => setCurrentPage('home')} currentUser={currentUser} />;
    default:
      return <ManagementHomePage onNavigate={setCurrentPage} onBackToGears={onBackToGears} currentUser={currentUser} />;
  }
};

export default ManagementGearPage;
